import global from '../global'

const orderList = global.serverUrl + '/backstage/trade/order/list'
const orderProductList = global.serverUrl + '/backstage/trade/order/product/list'
const orderBuyOffline = global.serverUrl + '/pay/trade/order/buy/offline'
const orderCheckTransfer = global.serverUrl + '/backstage/trade/checkout/transfer'
const orderTransferList = global.serverUrl + '/backstage/trade/transfer/list'
export default {
  orderList,
  orderProductList,
  orderBuyOffline,
  orderCheckTransfer,
  orderTransferList
}



// WEBPACK FOOTER //
// ./src/config/api/trade.js